var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.2002H17.25V4.81325L17.8508 4.9352L18 4.2002ZM26 23H25.25V23.75H26V23ZM6 23V23.75H6.75V23H6ZM14 4.2002L14.1492 4.9352L14.75 4.81325V4.2002H14ZM16 1V1.75C16.6904 1.75 17.25 2.30964 17.25 3H18H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1ZM18 3H17.25V4.2002H18H18.75V3H18ZM18 4.2002L17.8508 4.9352C22.0726 5.79221 25.25 9.52583 25.25 14H26H26.75C26.75 8.79836 23.0563 4.46129 18.1492 3.46519L18 4.2002ZM26 14H25.25V23H26H26.75V14H26ZM26 23V23.75H27V23V22.25H26V23ZM27 23V23.75C27.6904 23.75 28.25 24.3096 28.25 25H29H29.75C29.75 23.4812 28.5188 22.25 27 22.25V23ZM29 25H28.25C28.25 25.6904 27.6904 26.25 27 26.25V27V27.75C28.5188 27.75 29.75 26.5188 29.75 25H29ZM27 27V26.25H5V27V27.75H27V27ZM5 27V26.25C4.30964 26.25 3.75 25.6904 3.75 25H3H2.25C2.25 26.5188 3.48122 27.75 5 27.75V27ZM3 25H3.75C3.75 24.3096 4.30964 23.75 5 23.75V23V22.25C3.48122 22.25 2.25 23.4812 2.25 25H3ZM5 23V23.75H6V23V22.25H5V23ZM6 23H6.75V14H6H5.25V23H6ZM6 14H6.75C6.75 9.52583 9.92737 5.79221 14.1492 4.9352L14 4.2002L13.8508 3.46519C8.9437 4.46129 5.25 8.79836 5.25 14H6ZM14 4.2002H14.75V3H14H13.25V4.2002H14ZM14 3H14.75C14.75 2.30964 15.3096 1.75 16 1.75V1V0.25C14.4812 0.25 13.25 1.48122 13.25 3H14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27C19 28.6569 17.6569 30 16 30C14.3431 30 13 28.6569 13 27",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.25H26",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.25H26",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7a1b0ada464227f77b9a5dd85fadfb5f.svg";
export { ForwardRef as ReactComponent };